"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrystalsActive_OnTickEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
let CrystalsActive_OnTickEventHandlerScript = class CrystalsActive_OnTickEventHandlerScript {
    run(sequence, container, handler, event) {
        var _a;
        const ownerActorId = (_a = container.getActor(event.subject)) === null || _a === void 0 ? void 0 : _a.ownerId;
        const activeCrystals = Array.of("FireCrystalActive", "FrostCrystalActive", "NatureCrystalActive", "SonicCrystalActive").filter(key => container.readLocal(ownerActorId, key, false));
        if (!ownerActorId || activeCrystals.length === 0) {
            container.applyEffect(sequence, event.subject, event.subject, new core_1.DeathEffectArgs(), Duration_1.Duration.Permanent);
        }
    }
};
CrystalsActive_OnTickEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("CrystalsActive_OnTick")
], CrystalsActive_OnTickEventHandlerScript);
exports.CrystalsActive_OnTickEventHandlerScript = CrystalsActive_OnTickEventHandlerScript;
